var getClientImgSrc = function (_a) {
    var config = _a.config, client = _a.client, image = _a.image;
    return "".concat(config.hosts.assets.origin, "/assets/").concat(client, "/").concat(image);
};
export default getClientImgSrc;
